module.exports = __webpack_public_path__ + "sprites-32.02f6fddb1114975a58e2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/images/sprites/sprites-32.svg
// module id = 1
// module chunks = 2